import { useEffect, useState } from 'react';

import GalleryService from '@/services/gallery.service';

import InlinePostVideo from './InlinePostVideo';

export default function VideoDisplay({
  groupId,
  postId,
  video,
  previewMode,
  onRemove,
  onStatusChange,
}) {
  const [resolvedVideo, setResolvedVideo] = useState(video);

  useEffect(() => {
    setResolvedVideo(video);
  }, [video]);

  useEffect(() => {
    if (!video?.requiresSignedPlayback || !video?.assetId || !postId) return undefined;
    let active = true;
    GalleryService.getPostVideoPlayback(postId, video.assetId)
      .then(({ response, data }) => {
        if (active && response.ok && data?.playbackUrl) {
          setResolvedVideo(current => ({ ...current, ...data }));
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [postId, video?.assetId, video?.requiresSignedPlayback]);

  useEffect(() => {
    const shouldPollProcessing = !previewMode
      && typeof onStatusChange === 'function'
      && video?.assetId
      && video?.status !== 'failed'
      && video?.isFullyProcessed !== true;

    if (!shouldPollProcessing) return undefined;

    let active = true;
    const timer = window.setInterval(async () => {
      const { response, data } = await GalleryService.getPostVideoUploadStatus(video.assetId);
      if (!active || !response.ok || !data) return;

      setResolvedVideo(current => ({ ...current, ...data }));
      onStatusChange(data);

      if (data.isFullyProcessed || data.status === 'failed') {
        window.clearInterval(timer);
      }
    }, 3000);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [onStatusChange, previewMode, video?.assetId, video?.isFullyProcessed, video?.status]);

  return (
    <InlinePostVideo
      groupId={groupId}
      video={resolvedVideo}
      previewMode={previewMode}
      onRemove={onRemove}
    />
  );
}
